import styled from 'styled-components';
import DefaultClose from '../../svgs/Close';
import { StyledModalProps } from './types';

const opacity = '80';

export const Background = styled.div`
  background-color: ${({ theme }) =>
    theme.color.background.neutral.inverted + opacity};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.section<StyledModalProps>`
  background-color: ${({ theme }) => theme.color.background.neutral.default};
  width: ${({ $width }) => $width};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km6};
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin: 16px;
  }
`;

export const HighlightedMessage = styled.span`
  display: block;
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m3};
  color: ${({ theme }) => theme.color.text.neutral.default};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  margin-top: ${({ theme }) => theme.spacing.km8};
  letter-spacing: -0.03em;
`;

export const Close = styled(DefaultClose)`
  cursor: pointer;
  color: ${({ theme }) => theme.color.icon.neutral.default};
`;
